// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__G9XmC","baseloader":"style_baseloader__AoRTC"};